<template>
  <CSidebar
    fixed
    breakpoint="lg"
    class="bg-style1 sidebar-fixed-position"
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CRenderFunction flat :contentToRender="navs"/>
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',
  computed: {
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },
    navs() {
      void this.$store.state.locale.lang
      return [{
        _name: 'CSidebarNav',
        _children: [
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.dashboard'),
            to: 'dashboard',
            icon: 'cil-speedometer'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.repairs'),
            to: 'reportlist',
            icon: 'cil-window-restore'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.staff'),
            to: 'UsersList',
            icon: 'cil-people'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.jobTypes'),
            to: 'job-type',
            icon: 'cil-briefcase'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.buildings'),
            to: 'building',
            icon: 'cil-building'
          },
          {
            _name: 'CSidebarNavItem',
            name: this.$t('nav.userManual'),
            to: 'manual',
            icon: 'cil-book'
          },
        ]
      }]
    },
  },
}
</script>

<style scoped>
.bg-style1 {
  background: linear-gradient(30deg, #FFF0C4 0%, #145654 40%);
}

/* จัดตำแหน่งให้เริ่มใต้ Header (60px) */
.sidebar-fixed-position {
  top: 60px !important;       
  height: calc(100vh - 60px) !important; 
  z-index: 1020 !important;   
  position: fixed !important; 
  box-shadow: 2px 0 5px rgba(0,0,0,0.1); 
}

/* Sidebar nav item */
::v-deep .c-sidebar-nav-link {
  color: #ffffff;
  transition: all 0.25s ease;
  border-radius: 8px;
  margin: 4px 8px;
  position: relative;
  overflow: hidden;
}

/* Hover effect */
::v-deep .c-sidebar-nav-link:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(4px);
}

/* Icon animation */
::v-deep .c-sidebar-nav-link .c-sidebar-nav-icon {
  transition: transform 0.25s ease;
}

::v-deep .c-sidebar-nav-link:hover .c-sidebar-nav-icon {
  transform: scale(1.1);
}

/* Active menu */
::v-deep .c-sidebar-nav-link.c-active {
  background: rgba(255, 255, 255, 0.25);
  font-weight: 700;
}

/* Active left indicator */
::v-deep .c-sidebar-nav-link.c-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 4px;
  border-radius: 4px;
  background: #ffd666;
}

/* Smooth open animation */
::v-deep .c-sidebar-nav {
  animation: sidebarFadeIn 0.4s ease;
}

@keyframes sidebarFadeIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>

<style>
@media (max-width: 991.98px) {
  .c-sidebar-backdrop {
    display: none !important;
  }
}
</style>